import { Link } from 'react-router-dom';
import LogoDark from '../../images/logo/logo-dark.svg';
import axios from 'axios';
import { useState, useContext, useEffect } from 'react';
import Logo from '../../images/icon/black-majles-logo.png';
import { DataContext } from '../../context/DataProvider';

// import {
//   loadCaptchaEnginge,
//   LoadCanvasTemplate,
//   LoadCanvasTemplateNoReload,
//   validateCaptcha,
// } from 'react-simple-captcha';
import Captcha from './Captcha';
const SignIn = () => {
  useEffect(() => {
    // loadCaptchaEnginge(6);

    return () => {};
  }, []);
  const {
    setUserName,
    setPassword,
    username,
    password,
    fetchLoginJWT,
    expiry,
    // edame,
    tokenLogin,
    FetchLoginLawMinerPlus,
    RefreshCaptcha, setRefreshCaptcha,RegisterCaptcha, setRegisterCaptcha,
  }:any = useContext(DataContext);
  // localStorage.setItem('expiry', JSON.stringify(expiry));
  // localStorage.setItem('edame', JSON.stringify(edame));
  localStorage.setItem('tokenLogin', JSON.stringify(tokenLogin));
  const ShowCaptcha = process.env.REACT_APP_SHOW_CAPTCHA;

  const [generatedCaptcha, setGeneratedCaptcha] = useState("");
  const [CatpchaText, setCatpchaText] = useState("");


  function submitHandler(e) {
    e.preventDefault();

    if (ShowCaptcha == "true") {
      // let user_captcha_value =document.getElementById("user_captcha_input").value;
      if (CatpchaText !=="" && generatedCaptcha === CatpchaText) {
        fetchLoginJWT()
      } else {
        setRefreshCaptcha(true);
        setCatpchaText("")
        alert("لطفا کپچا را قبل از ارسال فرم بررسی نمایید.");
      }
    } else {
      // fetchLoginJWT();
    }
    // localStorage.setItem('tokenLogin', JSON.stringify(tokenLogin));
  }



  // const submitHandler = () => {
  //   let user_captcha_value =
  //     document.getElementById('user_captcha_input').value;

  //   if (validateCaptcha(user_captcha_value) == true) {
  //     //  alert('Captcha Matched');
  //     fetchLoginJWT();
  //   } else {
  //     //  alert('Captcha Does Not Match');
  //     alert('لطفا کپچا را قبل از ارسال فرم بررسی نمایید.');
  //   }
  //   let user_captcha = document.getElementById('user_captcha_input').value;

  //   if (validateCaptcha(user_captcha) === true) {
  //     // alert('Captcha Matched');
  //     loadCaptchaEnginge(6);
  //     document.getElementById('user_captcha_input').value = '';
  //     fetchLoginJWT();
  //   } else {
  //     alert('"لطفا کپچا را قبل از ارسال فرم بررسی نمایید.');
  //     document.getElementById('user_captcha_input').value = '';
  //   }
  // };

  // const loadCaptchaAgain = () => {
  //   loadCaptchaEnginge(6);
  // };
  // if (tokenLogin=="Password : The Password field is required." || tokenLogin =='user not found' || tokenLogin=='UserName : The UserName field is required.') {
  //   alert('نام ورود یا کلمه عبور اشتباه است، لطفا دوباره تلاش کنید.');
  //   window.location.assign("/")
  
  // }
  // else if(tokenLogin==""){
  //   window.location.assign("/")
  // }
  // else {
  // window.location.assign('/home');
  // }
  

  return (
    <>
      <div className="py-6 px-4" style={{ fontFamily: 'Btitr' }}>
        <a
          title="صفحه اصلی"
          className="text-black fixed top-[20px] left-[20px] hover:text-gray-700 duration-200"
          href="#"
        >
          {' '}
        </a>
        <div className="flex bg-white relative rounded-lg border max-w-[600px] border-gray-300 shadow-lg overflow-hidden mx-auto">
          <div className="w-full p-10">
            <h2 className="flex justify-center">
              <img width={130} height={130} src={Logo} alt="" />
            </h2>
            <div className="mt-7 flex items-center justify-between">
              <span className="border-b border-gray-300 w-1/5 lg:w-[30%]"></span>
              <a href="#" className="text-sm text-center text-gray-500 ">
                ورود کاربر{' '}
              </a>
              <span className="border-b border-gray-300 w-1/5 lg:w-[30%]"></span>
            </div>
            <div className="mt-4">
              <label className="block text-gray-700 text-sm mb-2">
                نام کاربری
              </label>
              <div className="relative">
                <input
                  className="bg-gray-100 text-gray-700 border border-gray-300 rounded py-2 pl-4 pr-10 block w-full appearance-none focus:outline-none focus:shadow-outline focus:border-primary"
                  type="email"
                  value={username}
                  onChange={(e) => setUserName(e.target.value)}
                />
              </div>
            </div>
            <div className="mt-4">
              <label className="block text-gray-700 text-sm mb-2">
                رمز عبور
              </label>
              <div className="relative">
                <input
                  id="password-input"
                  className="bg-gray-100 text-gray-700 border border-gray-300 rounded py-2 pl-4 pr-10 block w-full appearance-none focus:outline-none focus:shadow-outline focus:border-primary"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <button id="show-btn"></button>
              </div>
            </div>
            <div>
              {' '}
              <a
                className="text-[12px] text-primary hover:text-black duration-200"
                href="#"
              >
                رمز عبور خود را فراموش کردید ؟
              </a>
            </div>

            {/* <div className="flex items-center justify-center gap-2 mt-5">
              <input type="checkbox" id="remember-me" />
              <label className="text-[12px] " htmlFor="remember-me">
                مرا به خاطر بسپار
              </label>
            </div> */}
            {/* <div className="">
              <div className="container flex items-center justify-center gap-2 mt-5">
                <div className="form-group flex flex-col items-center justify-center">
                  <div className="row  mx-0 align-items-center justify-content-between">
                    <div className="col-4 mt-3 flex">
                      <div
                        className="col-3 algin-items-center text-2xl btn btn-lg cursor-pointer"
                        onClick={() => loadCaptchaAgain()}
                      >
                        &#x21bb;
                      </div>
                      <LoadCanvasTemplateNoReload
                        reloadColor="red"
                        reloadText="reload"
                      />

                    </div>
                  </div>

                  <p className="text-sm">
                    {' '}
                    کپچا به حروف کوچک و بزرگ حساس می باشد
                  </p>
                  <div className="col mt-3">
                    <input
                      placeholder="لطفا مقدرا کپچا را وارد کنید"
                      id="user_captcha_input"
                      name="user_captcha_input"
                      type="text"
                      className="w-[100%] p-2 border-2 border-gray-400 rounded-lg outline-none"
                    ></input>
                  </div>

                  <div className="col mt-3">
                  </div>
                </div>
              </div>
            </div> */}

{ShowCaptcha == "true" ? (
                    <div className="w-full  flex rtl md:px-5 px-5 ">
                      <div className="flex items-center justify-between w-full mt-1 ">
                        <input
                        value={CatpchaText}
                          placeholder="لطفا مقدار کپچا را وارد کنید"
                          id="user_captcha_input"
                          name="user_captcha_input"
                          type="text"
                          onChange={(e) => setCatpchaText(e.target.value)}
                          className="border w-full focus:outline-none rounded-md py-2 border-gray-300   px-3 text-[14px]"
                        />
                        {/* <LoadCanvasTemplateNoReload
                          // reloadColor="red"
                          // reloadText="reload"
                          className="text-sm"
                        /> */}
                        <div className="mr-3">
                          <Captcha
                            boxHeight={40}
                            boxWidth={110}
                            refreshButton
                            caseType="lowercase"
                            captchaConfig={{
                              numberOfChars: 4,
                              font: "bold 23px Arial",
                              textStartingX: 15,
                              textStartingY: 5,
                            }}
                            setCode={(captchaCode:string) =>
                              setGeneratedCaptcha(captchaCode)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}






            <div className="mt-8 flex justify-center">
              <button
                className=" w-[30%] bg-primary border-2  rounded-lg p-3 text-white hover:bg-white hover:text-primary
               hover:border-blue-500 "
              //  onClick={fetchLoginJWT}
              //  onClick={FetchLoginLawMinerPlus}
                onClick={submitHandler}
              >
                ورود{' '}
              </button>
            </div>
            <div className="mt-10 flex items-center justify-between">
              <span className="border-b border-gray-300 w-1/5 md:w-1/4"></span>
              <a href="/auth/signup" className="text-xs text-gray-500 mx-2 ">
                حساب کاربری ندارید؟{' '}
                <span className="text-primary">ثبت نام کنید </span>
              </a>
              <span className="border-b border-gray-300 w-1/5 md:w-1/4"></span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignIn;
